import * as ACTION_TYPES from './auditActionTypes';

export const auditReducerInitialState = {
	auditList: {
		isFetching: false,
		hasError: false,
		error: undefined,
		data: undefined
	},
	auditsUsersList: {
		isFetching: false,
		hasError: false,
		error: undefined,
		data: undefined
	},
	treasuryAuditList: {
		isFetching: false,
		hasError: false,
		error: undefined,
		data: undefined
	},
	treasuryAuditDetail: {
		isFetching: false,
		hasError: false,
		error: undefined,
		data: undefined
	}
};

export const auditReducer = ( state=auditReducerInitialState, action ) => {
	switch( action.type ) {

		case ACTION_TYPES.LIST_AUDIT_REQUEST: {
			return {
				...state,
				auditList: {
					...state.auditList,
					isFetching: true,
					hasError: false,
					data: auditReducerInitialState.auditList.data,
					error: auditReducerInitialState.auditList.error
				}
			};
		}

		case ACTION_TYPES.LIST_AUDIT_REQUEST_SUCCESS: {
			const { data } = action.payload;
			return {
				...state,
				auditList: {
					...state.auditList,
					isFetching: false,
					hasError: false,
					error: auditReducerInitialState.auditList.error,
					data
				}
			};
		}

		case ACTION_TYPES.LIST_AUDIT_REQUEST_FAILURE: {
			const { error } = action.payload;
			return {
				...state,
				auditList: {
					...state.auditList,
					isFetching: false,
					hasError: true,
					data: auditReducerInitialState.auditList.data,
					error
				}
			};
		}

		case ACTION_TYPES.CLEAR_AUDIT_LIST: {
			return {
				...state,
				auditList: auditReducerInitialState.auditList
			};
		}

		// list audits users
		case ACTION_TYPES.LIST_AUDITS_USERS_REQUEST: {
			return {
				...state,
				auditsUsersList: {
					...state.auditsUsersList,
					isFetching: true,
					hasError: false,
					data: auditReducerInitialState.auditsUsersList.data,
					error: auditReducerInitialState.auditsUsersList.error
				}
			};
		}

		case ACTION_TYPES.LIST_AUDITS_USERS_REQUEST_SUCCESS: {
			const { data } = action.payload;
			return {
				...state,
				auditsUsersList: {
					...state.auditsUsersList,
					isFetching: false,
					hasError: false,
					error: auditReducerInitialState.auditsUsersList.error,
					data
				}
			};
		}

		case ACTION_TYPES.LIST_AUDITS_USERS_REQUEST_FAILURE: {
			const { error } = action.payload;
			return {
				...state,
				auditsUsersList: {
					...state.auditsUsersList,
					isFetching: false,
					hasError: true,
					data: auditReducerInitialState.auditsUsersList.data,
					error
				}
			};
		}

		case ACTION_TYPES.CLEAR_AUDITS_USERS_LIST: {
			return {
				...state,
				auditsUsersList: auditReducerInitialState.auditsUsersList
			};
		}
		// END list audits users

		// treasury audit list
		case ACTION_TYPES.LIST_TREASURY_AUDIT_REQUEST: {
			return {
				...state,
				treasuryAuditList: {
					...state.treasuryAuditList,
					isFetching: true,
					hasError: false,
					data: auditReducerInitialState.treasuryAuditList.data,
					error: auditReducerInitialState.treasuryAuditList.error
				}
			};
		}

		case ACTION_TYPES.LIST_TREASURY_AUDIT_REQUEST_SUCCESS: {
			return {
				...state,
				treasuryAuditList: {
					...state.treasuryAuditList,
					isFetching: false,
					hasError: false,
					error: auditReducerInitialState.treasuryAuditList.error,
					data: action.payload.data
				}
			};
		}

		case ACTION_TYPES.LIST_TREASURY_AUDIT_REQUEST_FAILURE: {
			return {
				...state,
				treasuryAuditList: {
					...state.treasuryAuditList,
					isFetching: false,
					hasError: true,
					data: auditReducerInitialState.treasuryAuditList.data,
					error: action.payload.error
				}
			};
		}

		case ACTION_TYPES.CLEAR_TREASURY_AUDIT_LIST: {
			return {
				...state,
				treasuryAuditList: auditReducerInitialState.treasuryAuditList
			};
		}

		// treasury audit detail
		case ACTION_TYPES.GET_TREASURY_AUDIT_DETAIL_REQUEST: {
			return {
				...state,
				treasuryAuditDetail: {
					...state.treasuryAuditDetail,
					isFetching: true,
					hasError: false,
					data: auditReducerInitialState.treasuryAuditDetail.data,
					error: auditReducerInitialState.treasuryAuditDetail.error
				}
			};
		}

		case ACTION_TYPES.GET_TREASURY_AUDIT_DETAIL_REQUEST_SUCCESS: {
			return {
				...state,
				treasuryAuditDetail: {
					...state.treasuryAuditDetail,
					isFetching: false,
					hasError: false,
					error: auditReducerInitialState.treasuryAuditDetail.error,
					data: action.payload.data
				}
			};
		}

		case ACTION_TYPES.GET_TREASURY_AUDIT_DETAIL_REQUEST_FAILURE: {
			return {
				...state,
				treasuryAuditDetail: {
					...state.treasuryAuditDetail,
					isFetching: false,
					hasError: true,
					data: auditReducerInitialState.treasuryAuditDetail.data,
					error: action.payload.error
				}
			};
		}

		case ACTION_TYPES.CLEAR_TREASURY_AUDIT_DETAIL: {
			return {
				...state,
				treasuryAuditDetail: auditReducerInitialState.treasuryAuditDetail
			};
		}
		// END treasury audit

		default: {
			return state;
		}
	}
};

export const getAuditReducer = state => state.auditReducer;

export const getAuditList = state => getAuditReducer(state)?.auditList;
export const getAuditListData = state => getAuditList(state)?.data;
export const getAuditListIsFetching = state => getAuditList(state)?.isFetching;
export const getAuditListHasError = state => getAuditList(state)?.hasError;
export const getAuditListError = state => getAuditList(state)?.error;

// Getter list audits users
export const getAuditsUsersList = state => getAuditReducer(state)?.auditsUsersList;
export const getAuditsUsersListData = state => getAuditsUsersList(state)?.data;
export const getAuditsUsersListMetadata = state => getAuditsUsersListData(state)?.metadata;
export const getAuditsUsersListIsFetching = state => getAuditsUsersList(state)?.isFetching;
export const getAuditsUsersListHasError = state => getAuditsUsersList(state)?.hasError;
export const getAuditsUsersListError = state => getAuditsUsersList(state)?.error;
// Getters treasury audit list
export const getTreasuryAuditList = state => getAuditReducer(state)?.treasuryAuditList;
export const getTreasuryAuditListData = state => getTreasuryAuditList(state)?.data;
export const getTreasuryAuditListIsFetching = state => getTreasuryAuditList(state)?.isFetching;
export const getTreasuryAuditListHasError = state => getTreasuryAuditList(state)?.hasError;
export const getTreasuryAuditListError = state => getTreasuryAuditList(state)?.error;

// Getters treasury audit detail
export const getTreasuryAuditDetail = state => getAuditReducer(state)?.treasuryAuditDetail;
export const getTreasuryAuditDetailData = state => getTreasuryAuditDetail(state)?.data;
export const getTreasuryAuditDetailIsFetching = state => getTreasuryAuditDetail(state)?.isFetching;
export const getTreasuryAuditDetailHasError = state => getTreasuryAuditDetail(state)?.hasError;
export const getTreasuryAuditDetailError = state => getTreasuryAuditDetail(state)?.error;
